import { formatDate, isNotPostedExceptionReview } from 'functions';
import { InvoiceSummary } from 'types';

type Props = {
    invoice: InvoiceSummary
}

export default function InvoicePaymentStatus({ invoice }: Props) {       
    // Paid
    if (invoice.paymentDate)
        return <span>Paid on {formatDate(new Date(invoice.paymentDate))}</span>

    // Vouchered - Not Posted - Exception Review
    if (isNotPostedExceptionReview(invoice))
        return <span>Vouchered - Not Posted - Exception Review</span>

    // Vouchered - Scheduled to Pay
    if (invoice.scheduledPayDate)
        return <span>Vouchered - Scheduled to Pay</span>

    // Vouchered - Contact BDM
    if (invoice.paymentHoldFlag)
        return <span>Vouchered - Contact BDM</span>

    // Default if payment status has not been determined
    return <span>Status Not Available - Contact BDM</span>
}
